<template>
<div class="w-100" style="height:100%;overflow:auto">
    <ul class="metadata-dock-ul" :class="isMetadataDock?'':'align-texts'" v-on:scroll="loadMoreSubclips($event)" style="margin-bottom:0px !important">
      <template>
        <div v-for="eachId in metadataScreenInfo.field_id_list" :key="eachId" class="fields-styles">
          <div v-if="displayAlwaysFieldsIdList.includes(eachId) || profileDetails.custom_metadata_allId_list ||
                (profileDetails.custom_metadata_display_config > 0 && fetchedFieldIdList.includes(eachId)) ||
                selectedRelaventProfileIdList.includes('All')">
            <div v-for="custommetadata in (customMetadataList.filter((cmdata)=>cmdata._id == eachId))" :key="custommetadata._id">
              <li  :id="'field-'+custommetadata._id" class="d-block" :key="custommetadata._id"
                     @dblclick="editMetadataOnDoubleclick(custommetadata.name,custommetadata._id, custommetadata.type,custommetadata.type == 'PICKLIST_MULTIVALUE')"
                    :class="{'readonlyDiv':metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id),'li-style-change':isMetadataEdit(custommetadata.name)}">
                <div style="display: flex;">
                    <div class="upload-fields" :class="{readonlyDiv:metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id)}">
                    <div style="display: flex;">
                      <div class="key-style">{{ getCustomMetadataName(custommetadata) }}
                        <span class="readonly-field" v-if="metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id)">
                          ( non editable )
                        </span>
                      </div>
                      <span style="color:#858585" v-if="metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)">*</span>
                    </div>
                    <div class="value-style d-inline-flex">
                        <div class="w-100" style="display: inherit">
                        <div class="d-inline-flex">
                            <template v-if="!isMetadataEdit(custommetadata.name)">
                            <template v-if="custommetadata.type=='PICKLIST_MULTIVALUE'">
                                <div>
                                  <ul class="tags-display-ul p-0">
                                    <li
                                    v-for="picklist in pickListMapper[custommetadata._id]"
                                    :key="picklist.value_id"
                                    class="view-tags"
                                    >
                                      <div style="position:relative;top:1px">{{ picklist.value }}</div>
                                    </li>
                                  </ul>
                                </div>
                            </template>
                            <template v-else-if="custommetadata.type == 'PICKLIST'">
                              <span>{{getSinglePicklistVal(custommetadata._id)}}</span>
                            </template>
                            <template v-else>
                                <span>{{getCustomMetadataValue(custommetadata._id)}}</span>
                            </template>
                            </template>
                            <edit-icon
                            tabindex="0" @click.native="editMetadataDockFields(custommetadata.name,custommetadata._id, custommetadata.type,(custommetadata.type == 'PICKLIST_MULTIVALUE'))"
                            v-show="!isMetadataEdit(custommetadata.name) && isMetadataPrivEnabled() &&
                            !(metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id))"
                            class="editIcon"
                            ></edit-icon>
                            <div class="aboutField" :title="custommetadata.about_field" v-if="Object.keys(custommetadata).includes('about_field') &&
                            custommetadata.about_field.length" @click="enableOrDisableFieldInfo(custommetadata._id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#939393" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                            </svg>
                            </div>
                        </div>
                        <input
                            v-model="customMapper[custommetadata._id]"
                            type="text"
                            v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'FREETEXT'"
                            class="bg-transparent border rounded input-fields text-light w-100"
                            :id="custommetadata._id"
                            :ref="custommetadata.name"
                        />
                        <textarea
                            v-model="customMapper[custommetadata._id]"
                            type="text"
                            v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'FREETEXT_MULTILINE'"
                            class="bg-transparent rounded text-light w-100"
                            style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;
                            :1px solid #3a3a3a !important;"
                            :ref="custommetadata.name"
                            :id="custommetadata._id">
                        </textarea>
                        <input
                            v-model="customMapper[custommetadata._id]"
                            type="number"
                            v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'INTEGER'"
                            class="bg-transparent border rounded input-fields text-light w-100"
                            :id="custommetadata._id"
                            :ref="custommetadata.name"
                        />
                        <date-picker
                            v-model="time1"
                            v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'DATE'"
                            valueType="format"
                            class="bg-transparent border rounded input-fields text-light w-100"
                            :id="custommetadata._id"
                            :ref="custommetadata.name"
                        ></date-picker>
                        <date-picker
                            v-model="dateTime"
                            v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'DATE_TIME'"
                            type="datetime"
                            class="bg-transparent border rounded input-fields text-light w-100"
                            valueType="format"
                            :id="custommetadata._id"
                            :ref="custommetadata.name"
                            confirm
                        ></date-picker>
                        <Multiselect
                            v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'PICKLIST'"
                            :value="singlePickListMapper[custommetadata._id]"
                            :options="custommetadata.values"
                            :searchable="true"
                            :close-on-select="true"
                            :ref="custommetadata.name"
                            :allow-empty="false"
                            deselectLabel=""
                            track-by="value_id"
                            label="value"
                            selectLabel=""
                            selectedLabel=""
                            @select="picklistCheckFunc($event,custommetadata._id)"
                            placeholder="Select picklist"
                            style="margin-top: 7px;">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                            <Multiselect
                            v-show="custommetadata.type == 'PICKLIST_MULTIVALUE' && picklistTypeCheck(custommetadata) && isMetadataEdit(custommetadata.name)"
                            v-model="pickListMapper[custommetadata._id]"
                            :options="custommetadata.values"
                            :multiple="true"
                            :id="custommetadata._id"
                            @input="saveFields('custom_metadata', '',(metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)))"
                            :searchable="true"
                            :close-on-select="true"
                            :ref="custommetadata.name"
                            :allow-empty="false"
                            track-by="value_id"
                            label="value"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel="">
                            <span slot="noResult">No results</span>
                            <span slot="noOptions" style="display:none"></span>
                            <div slot="tag" slot-scope="option" class="selected-tags-style">
                            <div class="tags-display-style">{{option.option.value}}</div>
                                <div class="remove-tag" v-on:click="removeSelectedPicklistOption(option.option,custommetadata._id)">
                                    <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </div>
                            </div>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,custommetadata._id)" @focus.prevent :key="scope.option.name"/>
                            <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                            </div>
                        </Multiselect>
                        <div v-show="isMetadataEdit(custommetadata.name)">
                            <div class="d-flex">
                            <save-icon :wrapcontentwithbutton="true"
                               tabindex="0" @click.native="saveFields('custom_metadata', '',(metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)))"
                            class="save-cancel-icon"
                            ></save-icon>
                            <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                                @click.native="cancelMetadataDockFields(custommetadata.name)"
                            class="save-cancel-icon"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
              </li>
            </div>
          </div>
        </div>
      </template>
      <li v-if="hiddenFieldIdList.length > 0" class="d-inline-flex" style="    position: relative;
          bottom: 0px;
          inset-inline-start:0px;
          justify-content: start;border:none">
        <div> + {{hiddenFieldIdList.length}} {{$t('More fields are hidden')}}.</div>
        <div>
            <a href="#!" v-on:click="handleHiddenFieldsView" style="margin-inline-start: 5px;">{{$t('Show Fields')}}</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import EditIcon from "../core/InlineEditField";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import "vue2-datepicker/index.css";
// import BrowseIcon from "../core/InlineBrowseField.vue";
import Multiselect from 'vue-multiselect'
import {mapActions, mapGetters, mapMutations} from "vuex";
import Utils from "../../components.utils.js"
import Constants from "../../components.constants.js";
import {NotifierConstants} from "../../components.constants.js";

export default {
  props:["componentDetailsFromParent","screenType", "commentModule", "isDescriptionEditing", "isTicket"],
  data() {
    return {
      isMetadataDock:false,
      profileDetails:{
        "display_description":0,
        "custom_metadata_display_config":0,
        "tag_display_config": 0,
        "tag_displayall_config":0,
        "custom_metadata_id_list":[],
        "custom_metadata_allId_list":0,
        "tag_id_list":[]
      },
      showHiddenFields:false,
      hiddenFieldIdList:[],
      startupUserGroupList:[],
      tagMetadataScreenId:"",
      displayAlwaysFieldsIdList:[],
      fetchedFieldIdList:[],
      metadataScreenInfo:{
        "field_id_list":[],
        "read_only_field_id_list":[],
        "mandatory_field_id_list":[],
        "display_always_field_id_list":[]
        },
      selectedRelaventProfileIdList:["All"],
      isLoaded:false,
      time:null,
      time1:null,
      dateTime:null,
      picklistValue:{},
      postData:{},
      viewfieldInfoIds:[],
      route:"",
      editingMetadataKeyInDock:null,
      assetCustomMetadata : {"custom_metadata":[]},
      customMetadataList: [],
      editingCustomMetadata : {},
      cutomMetadatavalue:null,
      customMetadataCheck:null,
      customMapper:{},
      assetDetails:{},
      singlePickListMapper:{},
      pickListMapper:{},
      isCustomMetadataFieldsModified:false,
      actionsOnPlayer: false,
      audioUrl:null,
      controller:{},
      assetUpdatedThroughNotification:false,
      page:1,
      totalSubclipsPages:-1
    };
  },
  components:{
    "date-picker":DatePicker,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    Multiselect: Multiselect,
  },
  computed:{
    ...mapGetters("users",["getLoggedInUserId","getLoggedInUserPrivilege"])
  },
  methods:{
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    isMetadataPrivEnabled(){
        return true;
     // return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "tag-metadata")
    },
    customLabelPicklistSingleVal(option){
      return `${option}`
    },
      handleHiddenFieldsView(e){
        console.log(e); //
        e.preventDefault(); // prevent default behaviour of reload
        this.showHiddenFields = true;
        if(this.hiddenFieldIdList != undefined && this.hiddenFieldIdList.length > 0){
          for(let eId of this.hiddenFieldIdList){
            if(!this.metadataScreenInfo["field_id_list"].includes(eId)){
              this.metadataScreenInfo["field_id_list"].push(eId);
            }
          }
        }
        this.hiddenFieldIdList = [];
        this.selectedRelaventProfileIdList.push('All');
      },
      updateFieldsView(){
          this.profileDetails = {
            "display_description":0,
            "custom_metadata_display_config":0,
            "tag_display_config":0,
            "tag_displayall_config":0,
            "custom_metadata_id_list":[],
            "custom_metadata_allId_list":0,
            "tag_id_list":[]
          },
          this.fetchedFieldIdList = [];
          if(this.selectedRelaventProfileIdList != undefined && this.selectedRelaventProfileIdList.length > 0){
            for(let i= 0; i<this.selectedRelaventProfileIdList.length;i++){
              let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == this.selectedRelaventProfileIdList[i]);
              if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
                let profileDetail = {};
                Object.assign(profileDetail,STemplateDetails[0]);
                if(profileDetail.custom_metadata_id_list != undefined && profileDetail.custom_metadata_id_list.length > 0){
                  this.profileDetails.custom_metadata_display_config = this.profileDetails.custom_metadata_display_config + 1;
                }
                let idList = profileDetail.custom_metadata_id_list;
                for(let fId of idList){
                  if(this.fetchedFieldIdList.indexOf(fId) == -1 &&
                    this.displayAlwaysFieldsIdList.indexOf(fId) == -1){
                      this.fetchedFieldIdList.push(fId);
                  }else if(!this.hiddenFieldIdList.includes(fId)){
                    this.hiddenFieldIdList.push(fId);
                  }
                  if(!this.metadataScreenInfo.field_id_list.includes(fId) && !this.hiddenFieldIdList.includes(fId)){
                    this.hiddenFieldIdList.push(fId);
                  }
                }
              }
            }
            for(let sId of this.metadataScreenInfo.field_id_list){
              if(!this.fetchedFieldIdList.includes(sId) && !this.hiddenFieldIdList.includes(sId)){
                this.hiddenFieldIdList.push(sId);
              }
            }
          }else{
            this.hiddenFieldIdList = this.metadataScreenInfo.field_id_list;
          }
      },
      picklistCheckFunc(option,id){
        this.singlePickListMapper[id] = option;
        this.saveFields('custom_metadata', '',(this.metadataScreenInfo.mandatory_field_id_list != undefined && this.metadataScreenInfo.mandatory_field_id_list.includes(id)))
      },
      removeSelectedPicklistOption(option,id){
        this.pickListMapper[id] = this.pickListMapper[id].filter(e => e != option);
        this.saveFields('custom_metadata', '',(this.metadataScreenInfo.mandatory_field_id_list != undefined && this.metadataScreenInfo.mandatory_field_id_list.includes(id)));
      },
      selectPicklist(option,values){
        let index = values.findIndex(item => item == option);
        if(index > -1){
            values[index].checked = true;
            values.push(option)
        }
      },
      removePicklist(option,selectedValues){
        let index = selectedValues.findIndex(item => item._id == option._id);
          if(index > -1){
              selectedValues[index].checked = false;
              selectedValues = selectedValues.filter(e => e != option)
          }
      },
      makeTagsCheckBoxSelection(option){
          return this.selectedTags.some((op) => op._id === option._id);
      },
      makePicklistCheckBoxSelection(option,id){
        if(this.pickListMapper[id] != undefined){
          return this.pickListMapper[id].some((op) => op.value_id === option.value_id);
        }
      },
        picklistTypeCheck(custommetadata){
          let res =  custommetadata.type == 'PICKLIST_MULTIVALUE';
          if(res){
            if(!(custommetadata._id in this.pickListMapper)){
              this.pickListMapper[custommetadata._id] = this.getCustomMetadataValue(custommetadata._id, true)
            }
          }
          return res
        },
        getSinglePicklistVal(id){
          if(this.singlePickListMapper != undefined && this.singlePickListMapper[id] != undefined){
            return this.singlePickListMapper[id].value;
          }
          return "";
        },
        getCustomMetadataValue(id, multiValues=false){
             if(Object.keys(this.assetCustomMetadata).includes("custom_metadata")){
                let cmdata = this.assetCustomMetadata.custom_metadata.filter((cdata)=>cdata.key_id == id)[0];
                if(cmdata != undefined){
                  if(cmdata.value.length > 1 && !multiValues){
                    this.postData.cutomMetadatavalue = cmdata.value
                    return cmdata.value;
                  }else if(multiValues){
                    return cmdata.value
                  }else if(["DATE_TIME"].includes(cmdata.type)){
                    let cVal = cmdata.value[0];
                    cVal = cVal.replace("T", " ");
                    return cVal;
                  }else{
                    this.postData.cutomMetadatavalue = cmdata.value[0]
                    return cmdata.value[0];
                  }
                }
            }else{
                this.postData.cutomMetadatavalue = ""
                return ""
            }
          },
        
        enableOrDisableFieldInfo(fieldId){
          if(this.viewfieldInfoIds.indexOf(fieldId) == -1){
            this.viewfieldInfoIds.push(fieldId);
          }
          else{
            this.viewfieldInfoIds.splice(this.viewfieldInfoIds.indexOf(fieldId),1);
          }
        },
        isMetadataEdit(keyName) {
            // this.categoryListFromAutocomplete = [];
            return keyName === this.editingMetadataKeyInDock;
        },
        editMetadataDockFields(keyName, custMetadataKey=null, custMetadataType=null, custMetadataMultivalue=false) {
            if(!this.isMetadataPrivEnabled()){
              return;
            }
            this.editingMetadataKeyInDock = keyName;
            if(custMetadataType == 'DATE'){
              this.time1 = this.getCustomMetadataValue(custMetadataKey)
            }
            this.postData.cutomMetadatavalue = this.getCustomMetadataValue(custMetadataKey)
            if (custMetadataKey != null && custMetadataType != null){
                this.editingCustomMetadata = {"_id":custMetadataKey, "type": custMetadataType, "multi_values": custMetadataMultivalue}
            }
            this.autoFocusInputFields(keyName,custMetadataType);
        },
        editMetadataOnDoubleclick(keyName, custMetadataKey=null, custMetadataType=null, custMetadataMultivalue=false){
          
          if((this.commentModule == "Task" || this.commentModule == "Review") && this.isDescriptionEditing == true){
            this.$emit("checkIsUnsavedDescription", true);
          }

          if(!this.isMetadataPrivEnabled() ||
            (this.metadataScreenInfo.read_only_field_id_list != undefined &&
            this.metadataScreenInfo.read_only_field_id_list.includes(custMetadataKey))){
            return;
          }
          this.editingMetadataKeyInDock = keyName;
          if (custMetadataKey != null && custMetadataType != null){
            this.editingCustomMetadata = {"_id":custMetadataKey, "type": custMetadataType, "multi_values": custMetadataMultivalue}
          } 
          this.autoFocusInputFields(keyName,custMetadataType);
        },
        autoFocusInputFields(keyName,custMetadataType){
          this.$nextTick(() => {
          if(Object.prototype.toString.call(this.$refs[keyName]) == '[object Array]'){
            if(["DATE","DATE_TIME"].includes(custMetadataType)){
              setTimeout(() => {
                this.$refs[keyName][1].focus();
              }, 200);
            }else if(this.$refs[keyName].length > 0 && this.$refs[keyName][1].$el != undefined){
              setTimeout(() => {
                this.$refs[keyName][1].$el.focus();
              }, 200);
            }else if(this.$refs[keyName].length == 0 && this.$refs[keyName][0].$el != undefined){
              setTimeout(() => {
                this.$refs[keyName][0].$el.focus();
              }, 200);
            }else{
              this.$refs[keyName][1].focus();
            }
          }else if(Object.prototype.toString.call(this.$refs[keyName]) == '[object Object]'){
            if(this.$refs[keyName].$el != undefined){
              setTimeout(() => {
                this.$refs[keyName].$el.focus();
              }, 200);
            }else{
                this.$refs[keyName].focus();
            }
          }else {
              setTimeout(() => {
                this.$refs[keyName].focus();
              }, 200);
          }
          });
        },
        cancelMetadataDockFields() {
          this.editingMetadataKeyInDock = null;
          this.editingCustomMetadata = {};
          this.categoryListFromAutocomplete = [];
          this.postData.cutomMetadatavalue = "";
          if(this.assetUpdatedThroughNotification){
            this.updateMetadataOfAssetsThroughNotification(this.assetDetails._id);
            this.assetUpdatedThroughNotification = false
          }
        },
        saveFields(field,catId, isMandatoryField){
          let payload = {};
          payload.reviewId = this.componentDetailsFromParent._id
          let reviewObj = {}
          if(field == "custom_metadata"){
            this.customMetadataCheck = [];
            if (Object.keys(this.editingCustomMetadata).length != 0){
                if(["DATE"].includes(this.editingCustomMetadata.type)){
                  this.customMetadataCheck = [this.time1];
                }else if(["DATE_TIME"].includes(this.editingCustomMetadata.type) && this.dateTime){
                  let cVal = this.dateTime;
                  cVal = cVal.replace(" ","T")
                  this.customMetadataCheck = [cVal];
                }else if(['INTEGER','FREETEXT','FREETEXT_MULTILINE'].includes(this.editingCustomMetadata.type)){
                  if(typeof this.customMapper[this.editingCustomMetadata._id] != "undefined" &&
                   this.customMapper[this.editingCustomMetadata._id] != null){
                    this.customMetadataCheck = [this.customMapper[this.editingCustomMetadata._id]];
                   }
                }else if(this.editingCustomMetadata.type == "PICKLIST"){
                  this.customMetadataCheck = [this.singlePickListMapper[this.editingCustomMetadata._id].value_id];
                }else if(this.editingCustomMetadata.type == 'PICKLIST_MULTIVALUE'){
                  if(typeof this.pickListMapper != "undefined" && typeof this.pickListMapper[this.editingCustomMetadata._id] != "undefined"){
                    let vals = this.pickListMapper[this.editingCustomMetadata._id].filter((val)=>val.length != 0);
                    let valList = [];
                    for(let op of vals){
                      valList.push(op.value_id)
                    }
                    this.customMetadataCheck = valList;
                  }
                }else{
                  this.customMetadataCheck = [this.postData.cutomMetadatavalue];
                }
                
                if(this.commentModule != 'project'){
                  reviewObj["custom_metadata"] = [];
                }    
               
                let customKeyValue = {
                    key_id : this.editingCustomMetadata._id,
                    type : this.editingCustomMetadata.type,
                    value: this.customMetadataCheck,
                }

                if(this.commentModule == 'project'){
                  let projectCustomMetadataList = ('custom_metadata' in  this.componentDetailsFromParent && this.componentDetailsFromParent.custom_metadata)?this.componentDetailsFromParent.custom_metadata:[];
                  reviewObj["project_metadata"] = projectCustomMetadataList;
                  let index = projectCustomMetadataList.findIndex((obj)=> obj.key_id == customKeyValue.key_id);
                  if(index >=0){
                    reviewObj.project_metadata[index] = customKeyValue;
                  }else{
                    if(reviewObj["project_metadata"] && reviewObj["project_metadata"].indexOf(customKeyValue) ==-1)
                    reviewObj["project_metadata"].push(customKeyValue);
                  }
                }else{
                  reviewObj.custom_metadata.push(customKeyValue);
                }

                  let invalidKeyValue = false
                  if( isMandatoryField){
                    if(customKeyValue.value.length <= 0){
                      invalidKeyValue = true;
                    }else{
                      let valueList = customKeyValue.value;
                      for (let i = 0; i<valueList.length; i++){
                        if(valueList[i] == null || typeof valueList[i] == "undefined" || valueList[i].trim().length <= 0){
                          invalidKeyValue = true;
                          break;
                        }
                      }
                    }
                  }
                  if(invalidKeyValue){
                    let fieldEntry = this.customMetadataList.filter((cmdata)=>cmdata._id == this.editingCustomMetadata._id)[0]
                    alert(`"${fieldEntry.name}" is mandatory field. Please add valid value `)
                    return;
                  }
            }
          }
          payload.modules=this.commentModule;
          payload.params = reviewObj
          if(this.isTicket == true){
              payload.taskType = "Ticket";
          }
          this.updateReviewData(payload).then((data)=>{
                if (data.statusCode==200){
                  if(field == 'custom_metadata'){
                    let mInfoIdx = this.assetCustomMetadata["custom_metadata"].findIndex(op=>op.key_id==payload.params.custom_metadata[0].key_id);
                    if(mInfoIdx >= 0){
                      this.assetCustomMetadata.custom_metadata.splice(mInfoIdx, 1, payload.params.custom_metadata[0]);
                    }
                    this.assetDetails["custom_metadata"] = this.assetCustomMetadata.custom_metadata;
                  }
                  this.$toast.success("Updated");
                    // this.$toast.success(data.message);
                }else{
                    this.$toast.error(data.message);
                    this.categoryListFromAutocomplete = [];
                    if(field == "tags"){
                      this.selectedTags = this.cacheTagIdList;
                    }
                }
                this.editingCustomMetadata = {}
                this.showHiddenFields = false;
          })
          this.editingMetadataKeyInDock = null;
          this.editingCustomMetadata = {};
          this.tagNamesList = [];
        },
    closeMetadataManager(){
      this.$emit("close");
    },
    setAssetInfo(info){
      this.assetDetails = {}
      this.singlePickListMapper = {}
      this.pickListMapper = {}
      Object.assign(this.assetDetails, info)
      if(Object.keys(this.assetDetails).includes("custom_metadata")){
        this.assetCustomMetadata = {"custom_metadata":[]},
        Object.assign(this.assetCustomMetadata["custom_metadata"], this.assetDetails.custom_metadata);
        for(let eachF of info["custom_metadata"]){
          if(eachF.type == "PICKLIST_MULTIVALUE"){
              let CDetails = this.customMetadataList.filter(op=>op._id == eachF.key_id)
              if(CDetails.length > 0){
                let FInfo = [];
                for(let i of eachF.value){
                  let details = CDetails[0].values.filter(op=>op.value_id == i)
                  if(details.length > 0){
                    FInfo.push(details[0]);
                  }
                }
                this.pickListMapper[eachF.key_id] = FInfo;
              }
          }else if(eachF.type == "PICKLIST"){
              let CDetails = this.customMetadataList.filter(op=>op._id == eachF.key_id)
              if(CDetails.length > 0){
                let details = CDetails[0].values.filter(op=>op.value_id == eachF.value[0])
                if(details.length > 0){
                  this.singlePickListMapper[eachF.key_id] = details[0];
                }
              }
          }else{
            this.customMapper[eachF.key_id] = eachF.value[0];
            if(["DATE"].includes(eachF.type)){
              this.time1 = eachF.value[0]
            }else if(["DATE_TIME","DATE"].includes(eachF.type)){
              let cVal = eachF.value[0]
              cVal = cVal.replace("T", " ");
              this.dateTime = cVal;
            }
          }
        }
      }else{
        this.assetDetails["custom_metadata"] = [];
      }
      this.isLoaded=true 
    },
    fetchAndLoadRelaventMetadataProfiles(catalogId, assetFieldEntries){
      // this.showHiddenFields = false;
      this.hiddenFieldIdList = [];
      let profileList = [];
      if(this.metadataProfileList != undefined && this.metadataProfileList.length > 0){
        this.selectedRelaventProfileIdList = [];
        this.checkedProfiles = [];
        this.relevantProfilesList = [];
        for(let ItemS of this.metadataProfileList){
          let isProfileMatched = [];
          if(ItemS.load_when != undefined && ItemS.load_when.length > 0){
            for(let loadT of ItemS.load_when){
              // if(loadT.type == Constants.loadWhenCatalog){
              //   let catId = "";
              //   if(catalogId != undefined && catalogId.length > 0){
              //     catId = catalogId;
              //   }
              //   if(catId[0].includes(loadT.id_list[0])){
              //     isProfileMatched.push(true);
              //   }else{
              //     isProfileMatched.push(false);
              //     break;
              //   }
              // }else
              if(loadT.type == Constants.loadWhenMimeTypes){
                if(Object.keys(this.assetDetails).includes("mime_type") &&
                   this.assetDetails.mime_type != undefined &&
                   this.assetDetails.mime_type.startsWith(loadT.value)){
                  isProfileMatched.push(true);
                }else{
                  isProfileMatched.push(false);
                  break;
                }
              }else if(loadT.type == Constants.loadWhenScreenName){
                if(loadT.id_list.includes(this.tagMetadataScreenId)){
                  isProfileMatched.push(true);
                }else{
                  isProfileMatched.push(false);
                  break;
                }
              }else if(loadT.type == Constants.loadWhenUserName){
                if(loadT.id_list.includes(this.getLoggedInUserId)){
                  isProfileMatched.push(true);
                }else{
                  isProfileMatched.push(false);
                  break;
                }
              }else if(loadT.type == Constants.loadWhenGroupName){
                if(Utils.isUserExistsInOneSpecificGroupList(this.getLoggedInUserId, loadT.id_list, this.startupUserGroupList)){
                  isProfileMatched.push(true);
                }else{
                  isProfileMatched.push(false);
                  break;
                }
              }else if(loadT.type == Constants.loadWhenAdvancedExp){
                //loadWhen Advance exp. matches
              }else if(this.isFieldType(loadT.type)){
                for(let fId of loadT.id_list){
                  if(assetFieldEntries == undefined || assetFieldEntries.length <= 0){
                    continue;
                  }
                  let fieldEntryDetails = assetFieldEntries.filter(item=>item.key_id == fId);
                  if(fieldEntryDetails == undefined || fieldEntryDetails.length <= 0){
                    isProfileMatched.push(false);
                    break;
                  }
                  let isFieldValueMatched = false;
                  if(["FREETEXT","FREETEXT_MULTILINE"].includes(loadT.type)){
                    if(loadT.value == fieldEntryDetails[0].value[0]){
                      isFieldValueMatched = true;
                    }
                  }else if(["DATE"].includes(loadT.type)){
                    let fieldDate = fieldEntryDetails[0].value[0];
                    let fromDate = loadT.value[0];
                    let toDate = loadT.value[1];
                    if(fromDate <= fieldDate && fieldDate <= toDate){
                      isFieldValueMatched = true;
                    }
                  }else if(["DATE_TIME"].includes(loadT.type)){
                    let fieldDate = fieldEntryDetails[0].value[0];
                    fieldDate = fieldDate.replace("T"," ");
                    let fromDate = loadT.value[0];
                    fromDate = fromDate.replace("T", " ")
                    let toDate = loadT.value[1];
                    toDate = toDate.replace("T"," ");
                    if(fromDate <= fieldDate && fieldDate <= toDate){
                      isFieldValueMatched = true;
                    }
                  }else if(["INTEGER"].includes(loadT.type)){
                    if(fieldEntryDetails[0].value[0] >= loadT.value["from"] && fieldEntryDetails[0].value[0] <= loadT.value["to"]){
                      isFieldValueMatched = true;
                    }
                  }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(loadT.type)){
                    for(let val of loadT.value){
                      if(!fieldEntryDetails[0].value.includes(val)){
                        isFieldValueMatched = false;
                        break;
                      }
                      isFieldValueMatched = true;
                    }
                  }
                  if(isFieldValueMatched){
                    isProfileMatched.push(true);
                  }else{
                    isProfileMatched.push(false);
                    break;
                  }
                }
              }
            }
            if(isProfileMatched.includes(false)){
              if(this.selectedRelaventProfileIdList != undefined &&
                this.selectedRelaventProfileIdList.includes(ItemS._id)){
                this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf(ItemS._id), 1)
                this.checkedProfiles = this.checkedProfiles.filter(item => item.metadata_profile_id != ItemS._id)
              }
            }else{
              profileList.push({
                "metadata_profile_id":ItemS._id,
                "name":ItemS.name
              })
              this.selectedRelaventProfileIdList.push(ItemS._id);
            }
          }else if(!this.selectedRelaventProfileIdList.includes(ItemS._id)){
            profileList.push({
              "metadata_profile_id":ItemS._id,
              "name":ItemS.name
            })
            this.selectedRelaventProfileIdList.push(ItemS._id);
          }
        }
        if(this.selectedRelaventProfileIdList == undefined ||
         this.selectedRelaventProfileIdList.length <= 0 ||
          this.showHiddenFields){
          this.selectedRelaventProfileIdList.push('All');
        }
        this.checkedProfiles = profileList;
        this.relevantProfilesList = profileList;
        // this.relevantProfilesList.push({"metadata_profile_id":"All","name":"All"});
      }
      this.updateFieldsView();
    },
    isFieldType(fieldType){
      return ["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","INTEGER","PICKLIST","PICKLIST_MULTIVALUE"].includes(fieldType);
    },
    refreshStartData(keyName){
      if(keyName == "custom_metadatas" && Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
        this.customMetadataList = this.getStartUpDataFromInCache()["custom_metadatas"];
      }else if(keyName == "screens" && Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
        let screenExists = false;
        let screens = this.getStartUpDataFromInCache()["screens"];
        if(screens.length > 0){
          let screensList = screens.filter((a)=>a.name == this.screenType);
          if(screensList.length > 0){
            screenExists = true;
            let screenDetails = screensList[0];
            this.metadataScreenInfo = JSON.parse(JSON.stringify(screenDetails));
            this.tagMetadataScreenId = screenDetails._id;
            let displayAlwaysList = screenDetails.display_always_field_id_list;
            if(typeof displayAlwaysList != "undefined" && displayAlwaysList.length > 0){
                this.displayAlwaysFieldsIdList = displayAlwaysList;
                this.fetchedFieldIdList = this.displayAlwaysFieldsIdList;
            }
          }
        }
        if(!screenExists){
          for(let eachDict of this.customMetadataList){
            this.metadataScreenInfo.field_id_list.push(eachDict._id);
          }
        }
      }
    },
    updateMetadataOfAssetsThroughNotification(componentId){
        this.getServerIndReviewData(componentId).then((data) => {
          let info  = data["review"];
          this.setAssetInfo(info)
        })
    },
    handleNotifications(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
          let entry_info = notification.message
          if(notification.message_type == NotifierConstants.screenModifiedNotification){
            if(this.tagMetadataScreenId == entry_info.screen_id){
              setTimeout(()=>{
                this.refreshStartData("screens");
                // if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                //   this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails.catalog_id_path, this.assetDetails["custom_metadata"]);
                // }
              },100);
            }
           }else if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
                      setTimeout(()=>{
                        this.refreshStartData("custom_metadatas");
                        // if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                        //   this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails.catalog_id_path, this.assetDetails["custom_metadata"]);
                        // }
                      }, 100);
          }else if([NotifierConstants.fieldModifiedNotification,
                    NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
                      setTimeout(()=>{
                        this.refreshStartData("custom_metadatas");
                        // if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                        //   this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails.catalog_id_path, this.assetDetails["custom_metadata"]);
                        // }
                      }, 100);
          }else if(NotifierConstants.assetModifiedNotification == notification.message_type){
            if (this.assetDetails._id == notification.message._id){
                if(this.editingMetadataKeyInDock == null){
                  this.assetUpdatedThroughNotification = false;
                  this.updateMetadataOfAssetsThroughNotification(this.assetDetails._id);
                }else{
                  this.assetUpdatedThroughNotification = true;
                }
              }
          }
      }
    },
    
    handleFiledsUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        // let component_info = {};
        if(this.commentModule == "Task"){
          let notificaitonMessage = notification.message;
          if(this.componentDetailsFromParent._id == notificaitonMessage._id){
            this.setUpdatedFeildValue(notificaitonMessage);
          }  
          // component_info = notification.message.task;
        }else{
          // component_info = notification.message.review;
          // if ( !['undefined', undefined,null].includes(this.componentDetailsFromParent) && component_info._id == this.componentDetailsFromParent._id){
          //   this.setAssetInfo(component_info) 
          // }
          let notificaitonMessage = notification.message;
          if(this.componentDetailsFromParent._id == notificaitonMessage._id){   
            this.setUpdatedFeildValue(notificaitonMessage);
          }  
        }

        // if ( !['undefined', undefined,null].includes(this.componentDetailsFromParent) && component_info._id == this.componentDetailsFromParent._id){
        //    this.setAssetInfo(component_info) 
        // } 
        // ----moving these line lines into else condition in the above, since this is not required in TAsks context
    },

    setUpdatedFeildValue(nMessage){
      if(this.screenType == "Customer Ticket"){
        if(this.isClientUser() && nMessage.modified_by_userId != this.getLoggedInUserId){
          return;
        }
      }
      for(let op of Object.keys(nMessage)){
        if(op == "custom_metadata" || op == "project_metadata"){
          if(nMessage[op].length <= 0){
            continue;
          }
          let fieldObj = nMessage[op][0];
          if(fieldObj.type == "PICKLIST_MULTIVALUE"){
            let eI = this.pickListMapper;
            this.pickListMapper = {};
            let CDetails = this.customMetadataList.filter(op=>op._id == fieldObj.key_id)
            if(CDetails.length > 0){
              let FInfo = [];
              for(let i of fieldObj.value){
                let details = CDetails[0].values.filter(op=>op.value_id == i)
                if(details.length > 0){
                  FInfo.push(details[0]);
                }
              }
              eI[fieldObj.key_id] = FInfo;
            } 
            this.pickListMapper = eI;
          }else if(fieldObj.type  == "PICKLIST"){
            let eI = this.singlePickListMapper;
            this.singlePickListMapper = {};
            let CDetails = this.customMetadataList.filter(op=>op._id == fieldObj.key_id)
            if(CDetails.length > 0){
              let details = CDetails[0].values.filter(op=>op.value_id == fieldObj.value[0])
              if(details.length > 0){
                eI[fieldObj.key_id] = details[0];
              }
            }
            this.singlePickListMapper = eI
          }else{
            if(["DATE"].includes(fieldObj.type)){
              this.time1 = fieldObj.value[0];
            }else if(["DATE_TIME"].includes(fieldObj.type)){
              let cVal = fieldObj.value[0];
              cVal = cVal.replace("T", " ")
              this.dateTime = cVal;
            }
          }
          if(Object.keys(this.assetCustomMetadata).includes(op)){
              let fIdx = this.assetCustomMetadata.custom_metadata.findIndex((cdata)=>cdata.key_id == fieldObj.key_id)[0];
              if(fIdx >= 0){
                this.assetCustomMetadata.custom_metadata.splice(fIdx,1,fieldObj)
              }else{
                let eData = this.assetCustomMetadata.custom_metadata
                eData.unshift(fieldObj)
                this.assetCustomMetadata.custom_metadata = eData;
              }
          }else{
            this.assetCustomMetadata["custom_metadata"] = nMessage[op];
          }
        }
      }
    },

    isClientUser(){
      if(this.getLoggedInUserType() == 'Client'){
        return true;
      }else{
        return false;
      }
    },

    ...mapActions("reviewWorkspaceData", ["getServerIndReviewData"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("files", ["getFileInfoFromServer"]),
    ...mapActions("tags", ["getTagsOnAutocomplete","getAllTagsFromServer"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("assets", ["getAssetInfoFromServer","getSubclipsFromServer","getAllAssetsFromServer"]),
    ...mapActions("assets",["getCategoryTreefromId"]),
    ...mapActions("reviewDataTemp", ["updateReviewData"]),
    // ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserType"]),
  },
  watch:{
      immediate:true,
      deep:true,
      componentDetailsFromParent(newVal,oldVal){
        if(oldVal != newVal){
          this.refreshStartData('custom_metadatas');
          this.refreshStartData("screens");
          this.isLoaded=false;
          if(this.componentDetailsFromParent != undefined){
            this.setAssetInfo(this.componentDetailsFromParent) 
          }
        }
      },

      "componentDetailsFromParent.custom_metadata":function(newVal,oldVal){
        if(oldVal != newVal){
          this.refreshStartData('custom_metadatas');
          this.refreshStartData("screens");
          this.isLoaded=false;
          if(this.componentDetailsFromParent != undefined){
            this.setAssetInfo(this.componentDetailsFromParent) 
          }
        }
      },
  },
  created(){
    this.refreshStartData('custom_metadatas');
    this.refreshStartData("screens");
    this.isLoaded=false;
    if(this.componentDetailsFromParent != undefined){
      this.setAssetInfo(this.componentDetailsFromParent) 
    }
    this.addWSEventListener({
            eventname:[NotifierConstants.screenModifiedNotification,
            NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
            NotifierConstants.assetModifiedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification],
            callback:this.handleNotifications,
            parent:"TagMetadataComponent"})

    this.addWSEventListener({
              eventname:["REVIEW_UPDATED"],
              callback:this.handleFiledsUpdateNotification,
              parent: "ReviewMetadata"}); 

    this.addWSEventListener({
              eventname:["TASK_MODIFIED"],
              callback:this.handleFiledsUpdateNotification,
              parent: "ReviewMetadata"});     
    
    this.addWSEventListener({
              eventname:["PROJECT_MODIFIED"],
              callback:this.handleFiledsUpdateNotification,
              parent: "ReviewMetadata"});     



  },
  beforeDestroy(){
    
    this.removeWSEventListener({
        eventname:[NotifierConstants.screenModifiedNotification,
        NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
        NotifierConstants.assetModifiedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification],
        callback:this.handleNotifications,
        parent:"TagMetadataComponent"})

    this.removeWSEventListener({
              eventname:["REVIEW_UPDATED"],
              callback:this.handleFiledsUpdateNotification,
              parent: "ReviewMetadata"}); 

    this.removeWSEventListener({
              eventname:["TASK_MODIFIED"],
              callback:this.handleFiledsUpdateNotification,
              parent: "ReviewMetadata"});  
        
    this.removeWSEventListener({
              eventname:["PROJECT_MODIFIED"],
              callback:this.handleFiledsUpdateNotification,
              parent: "ReviewMetadata"});  
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;


.li-style-change{
  border: 1px solid $metadata-border-color-on-hover !important;
}


.metadata-dock-ul li .aboutField {
  visibility: hidden;
}

.metadata-dock-ul li:hover .aboutField {
  visibility: visible;
}

.readonlyDiv{
    background: transparent !important;
    border: none !important;
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

.selected-tags-style{
  background: $tags-background-color;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  .remove-tag{
    line-height:18px;
  }
}

.tags-display-ul{
  margin-inline-start:0px;
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
  label{
    padding: 0px 5px;
  }
}
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background:$primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

    /* width */
    ::-webkit-scrollbar {
     width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}
.activeNav,.activeNav:hover{
    color: $active-blue !important;
    border: 1px solid $metadata-border-color-on-hover;
}
.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $border-color;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}
.upload-fields{
    width: 100%;
    border-radius: 5px;
}

.modal-header .close {
    margin: -1rem -19px -0rem auto !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    height:50px;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        border-radius: 5px;
        width: 70px;
        font-size:14px;
        float:inline-end;
    }
}


.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: start;
}

.view-tags {
    font-size: 12px !important;
    height: 30px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: 1px solid $tags-border-color !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px 5px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    padding-top: 4px !important;
    background: $tags-background-color !important;
  span, div {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

span{
  white-space: pre-wrap;
}

.view-tags:hover {
  border: $border-color !important;
}

.activeTag{
    color: $active-blue !important;
}

.align-texts{
  li{
    .value-style{
      padding-inline-start: 5px !important;
    }
  }
}

.metadata-dock-ul {
  list-style-type: none;
  padding: 0px;
  user-select: none; 
  position:relative;
  margin-inline-start:0px;
  width:100%;
  background:$primary-background;
  overflow:auto;
  .fields-styles{
      margin-bottom:8px;
    li{
      margin-bottom:1px;
    }
  }
  li {
    display: inline-block;
    width: 100%;
    padding: 7px;
    border: $border-color;
    border-radius: 4px;
    margin: 4px 8px;
    width: 96%;
    position: relative;
    background:$primary-background;
    .key-style {
      color: $dull-text-color;
      width: auto;
      text-align: start;
      font-size: 14px;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    .value-style {
      color: $text-color;
      width: 97%;
      text-align: start;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-inline-end: 5px;
      padding-inline-start: 0px;
      .slug-ellipsis {
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .save-cancel-icon{
        position:relative;
        top:10px;
        inset-inline-start:5px;
        color:#fff;
      }
      .browse-icon{
        color:#636363 !important;
      }
    }
  }
  li:hover{
    border:1px solid $metadata-border-color-on-hover
  }
}

.display-subclips{
  width:100% !important;
}
/* .metadata-dock-ul li:hover {
  border: 1px solid $metadata-border-color-on-hover;
} */

/* .metadata-dock-ul li:focus {
  border: 1px solid $active-blue !important;
} */

.metadata-dock-ul li .editIcon {
  /* visibility: hidden; */
  opacity: 0;
}

.metadata-dock-ul li:hover .editIcon,.metadata-dock-ul li:focus-within .editIcon {
 /*  visibility: visible; */
  opacity:1;
}
.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 2%;
    top: 10px;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  min-width: 250Px;
  padding-inline-start:5px;
  padding-top: 2px;
  height:38px;
  outline: none;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.text-light{
  color: #b6b6b6 !important;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

::v-deep{
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$primary-background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: $primary-background;
}

.v-list-item--link:before{
  background-color:$primary-background;
}
.vjs_video_3-dimensions, .video-js{
    height:350px !important;
    width:100% !important;
}
.video-js{
    height:350px !important;
    width:100% !important;
}
.mx-input{
    background-color:$primary-background !important;
    border: none !important;
    color: #eee !important;
}
.mx-datepicker-main{
    border: 1px solid #2f2f2f !important;
    background: $primary-background !important;
}
.mx-calendar-content .cell:hover{
    background-color: $bg-color-on-hover !important;
}
.mx-datepicker-range{
  width:100%
}
.mx-datepicker{
  padding:0px !important;
}
.mx-calendar-content .cell:hover {
    color: #000000;
    background-color: #7d99b1;
}
.mx-icon-calendar{
  color: $dull-text-color ;
}

}
.secondary-btn-style:hover{
  text-decoration: underline;
}

.assets-details-in-metadata-manager{
    height:calc(100% - 348px);
    overflow:auto;
    padding:0px 15px;
}

.metadata-dock-ul{
    height:97%;
    display:inline-block;
    padding-bottom: 10px;
    margin-bottom:0px !important;
}

.metadata-dock-ul li:focus {
  border: 1px solid $active-blue !important;
}

// .input-fields {
//   border: none !important;
//   min-width: 250Px;
//   border: none !important;
//   border-bottom: 1px solid $active-blue !important;
// }

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: start;
        }
        .value-style{
            color: #b6b6b6;
            width: 70%;
            text-align: start;
        }
    }
}

.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    max-width: 50%;
    img{
        height:100%;
        width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


::v-deep{
  .multiselect {
    margin: 3px 0px;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
  }
  .multiselect__tags, .tags-style {
    background: transparent !important;
    border-bottom: none !important;
    border:none;
    // --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    // box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    // border-radius: 4px;
    // border-color: transparent;
    // -webkit-appearance: none;
  }
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
    word-break: break-all;
  }
  .multiselect__single{
    padding-inline-start: 9px !important;
    margin-top: 0px !important;
    padding-top: 6px !important;
  }
  .multiselect__input{
      padding-top:0px !important;
  }

  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }
  .multiselect__tags:focus, .multiselect__input:focus{
    outline: none;
    height: 38px;
    bottom: 0px;
    inset-inline-start:0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
    }

  .multiselect * {
    font-size: $input-field-and-label-font-size;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 8px !important;
    padding-inline-start:8px;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100%;
    min-height: 38px;
    height:auto;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute;
    display: block;
    background: $text-color;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    padding: 4px 0px 5px 0px;
  }
}

.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

// input,select,.multiselect__input,.mx-input,textarea{
//   --saf-0: rgba(var(--sk_highlight,18,100,163),1);
//     box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
//     border-radius: 4px;
//     border-color: transparent;
//     -webkit-appearance: none;
// }

.label-tree-style{
  font-size: 12px !important;
  color:$dull-text-color;
  margin-top:4px;
  word-break: break-all;
  white-space: pre-wrap;
  margin-inline-start:12px;
}

.all-users-selection:hover{
  background: $bg-color-on-hover;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}


input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-end: 5px;
}

.browse-icon{
    position: relative;
    inset-inline-start:8px;
    top: 3px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}

.user-name-or-image-in-selected-option{
  border: $border-color;
  height: 26px;
  width: 26px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}

textarea{
  height:150px !important;
  resize: none;
  overflow: auto;
}
.edit-icon-style{
  visibility: hidden;
  position: absolute;
  top:4px;
  inset-inline-end:5px;
  display:inline-flex;
  svg{
      margin-inline-end:5px;
  }
}

.subclips-section:hover{
  //  border: 1px solid $metadata-border-color-on-hover;
  .edit-icon-style{
    visibility: visible;
    position: absolute;
    top:4px;
    inset-inline-end:5px;
    display:inline-flex;
    svg{
      margin-inline-end:5px;
    }
  }
}
.subclips-section{
  background:transparent !important;
  padding:0px !important;
  border:none !important;
  margin-inline-end:0px !important;
  ul{
    margin-inline-start:0px;
    .display-subclips{
      margin:4px 0px !important;
    }
  }
}
</style>
